import { useState, forwardRef, useCallback } from 'react';
import { Pagination as MuiPagination, PaginationItem as MuiPaginationItem } from '@mui/material';
import paginationStyleBuilder from './PaginationStyle';
import { BackToStartSolidIcon, ChevronRightIcon, ChevronLeftIcon } from '../../Icons';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { idBuilder } from '../../internal';

/** Component enables the user to select a specific page from a range of pages.  */
import { jsx as _jsx } from "react/jsx-runtime";
export const Pagination = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    nextIcon,
    previousIcon,
    firstIcon,
    showFirstButton,
    page,
    disabled,
    defaultPage = 1,
    count = 1,
    sx,
    onChange,
    id,
    ...rest
  } = _ref;
  const [pageState, setPageState] = useState(defaultPage);
  const handleChange = useCallback((event, value) => {
    if (onChange) {
      onChange(value);
    }
    setPageState(value);
  }, []);
  const theme = useInterstateTheme();
  const paginationStyle = mergeSxStyle(paginationStyleBuilder(theme), sx);
  return /*#__PURE__*/_jsx(MuiPagination, {
    count: count,
    page: page ?? pageState,
    onChange: handleChange,
    disabled: disabled,
    renderItem: item => {
      return /*#__PURE__*/_jsx(MuiPaginationItem, {
        ...item,
        components: {
          previous: previousIcon || ChevronLeftIcon,
          next: nextIcon || ChevronRightIcon,
          first: firstIcon || BackToStartSolidIcon
        },
        id: id ? idBuilder('ids-pagination-item', id, `${item.type}-${item.page}`) : undefined,
        "data-testid": rest['data-testid'] ? idBuilder('ids-pagination-item', rest['data-testid'], `${item.type}-${item.page}`) : undefined
      });
    },
    showFirstButton: showFirstButton,
    shape: "rounded",
    boundaryCount: 0,
    siblingCount: 2,
    sx: paginationStyle,
    ref: ref,
    id: id ? idBuilder('ids-pagination', id) : undefined,
    "data-testid": rest['data-testid'] ? idBuilder('ids-pagination', rest['data-testid']) : undefined
  });
});
Pagination.displayName = 'Pagination';